/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const teamMoveGroupEntrySchema = z.object({
  count: z.int(),
  fromTeam: z.string().nullish(),
  toTeam: z.string().nullish(),
});
